import { LocationSchema } from '@fieldday/fielddayportal-model';
import { Box, CardMedia, Typography } from '@mui/material';
import { Location, encodeAddress } from "../../models/Activity";
import useGlobalStyles from "../../styles/globalStyles";
import ajv from "../../util/ajvConfig";
const validate = ajv.compile(LocationSchema);

export default function LocationPreviewBox({ location, eventPage, setWidth }: { location: Location, eventPage?: boolean, setWidth?: string }) {
  const globalStyles = useGlobalStyles();
  const validLocation = validate(location);
  const mapurl =
  `https://maps.googleapis.com/maps/api/staticmap?zoom=14&markers=${encodeAddress(location)}`+
  `&size=400x250&key=${import.meta.env.REACT_APP_MAPS_API_KEY}`

  return validLocation ?
    <Box my={eventPage ? 0 : 2} maxWidth={setWidth ? setWidth : "400px"}>
      <a href={`https://google.com/maps/search/${encodeAddress(location)}`} target="_blank" rel="noreferrer">
        <CardMedia
          component="img"
          image={mapurl}
          style={{ borderRadius: 8 }}
        />
      </a>
    </Box>
  : <Box my={2} className={globalStyles.mapPreview}>
      <Typography className={globalStyles.helperText} textAlign="center">
        Map preview will appear when you&apos;ve entered a valid address
      </Typography>
    </Box>
}
